import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function() {

  // let videotl = gsap.timeline({
  //   scrollTrigger: {
  //     trigger: ".featured-image-section",
  //     start: "top top",
  //     end: "bottom 30%",
  //     scrub: true
  //     //markers: true
  //   }
  // });
  //
  // videotl.from("#background_layer #layer_3", 1, { y: "10%", ease: "power2.out" })
  //   .from("#background_layer #layer_2", 1, { y: "5%", ease: "power2.out" }, 0)


  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".specter_animation__graphic-wrapper",
      start: "center center",
      end: "top 10%",
      endTrigger: '#environment',
      pin: true
    }
  });


  let largetl = gsap.timeline({
    scrollTrigger: {
      trigger: "#large",
      start: "top 90%",
      end: "bottom -50%",
      scrub: true,
      //markers: true
    }
  });

  largetl.fromTo("#large_mask_poly", { x: "-100%" }, { x: "100%" });

  let smalltl = gsap.timeline({
    scrollTrigger: {
      trigger: "#small",
      start: "top bottom",
      end: "bottom -50%",
      scrub: true,
      //markers: true
    }
  });

  smalltl.fromTo("#small_mask_poly", { x: "-100%" }, { x: "100%" });


  let colorstl = gsap.timeline({
    scrollTrigger: {
      trigger: "#colors",
      start: "top 90%",
      end: "bottom 10%",
      scrub: true,
      //markers: true
    }
  });

  colorstl.staggerFrom("#colors_layer circle", 1, { scale: "0", transformOrigin: "50% 50%", boxShadow: "0px 0px 20px 10px rgba(0,0,0,0.7)", }, .5)
    .staggerTo("#colors_layer circle", 1, { opacity: "0" }, .5);

  let focaltl = gsap.timeline({
    scrollTrigger: {
      trigger: "#focal",
      start: "top 90%",
      end: "bottom -10%",
      scrub: true,
      //markers: true
    }
  });

  focaltl.staggerFrom("#focal_layer .target-group", 1, { scale: "0", transformOrigin: "50% 50%" }, .5)
    .to("#background_layer #layer_1", 1, { scale: ".98", x: "0px", y: "0px", ease: "sine.inOut" }, ".5")
    .to("#background_layer #layer_3", 1, { scale: "1.04", x: "0px", y: "0px", ease: "sine.inOut" }, ".5")
    .to("#background_layer #layer_1", 1, { scale: "1", x: "0px", y: "0px", ease: "sine.inOut" }, "1.5")
    .to("#background_layer #layer_3", 1, { scale: "1", x: "0px", y: "0px", ease: "sine.inOut" }, "1.5")
    .staggerTo("#focal_layer .target-group", 1, { scale: "0", transformOrigin: "50% 50%" }, .5, "-=1.5");


  let envtl = gsap.timeline({
    scrollTrigger: {
      trigger: "#environment",
      start: "top 90%",
      end: "bottom 50%",
      scrub: true,
      //markers: true
    }
  });

  envtl.from("#state_outlines", 1, { opacity: 0 }).to("#usa_mask_bg", 1, { opacity: 0 }, "0")

  $(".bottom-transition").each(function() {

    let $container = $(this);
    let $bg_el = $container.find(".bottom-transition-layer_2");

    let bottomtransitionparallax = gsap.timeline({
      scrollTrigger: {
        trigger: $container,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        //markers: true
      }
    });

    bottomtransitionparallax.to($bg_el, { y: "20vh" });

  });

  // let ctatl = gsap.timeline({
  //   scrollTrigger: {
  //     trigger: ".spector-signup-form",
  //     start: "top center",
  //     toggleActions: 'play none, reverse, none'
  //     //markers: true
  //   }
  // });
  //
  // ctatl.staggerFrom(".spector-signup-form > *", 2, { opacity: 0, y: "+10%", ease: "ease.power2.out" }, .5)

});
